import axios from 'axios';

export const sbAxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_SB,
  timeout: 60000
});

export const userAxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_USER,
  timeout: 100000,
  headers: {
    Authorization: localStorage.getItem('jwt') ? `Bearer ${localStorage.getItem('jwt')}` : '',
    'Content-Type': 'application/json', "accept":"*/*"
  }
});

export const customerAxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_CUSTOMER,
  timeout: 100000,
  headers: {
    Authorization: localStorage.getItem('jwt') ? `Bearer ${localStorage.getItem('jwt')}` : '',
    'Content-Type': 'application/json', "accept":"*/*"
  }
});

export const lotAxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_LOT,
  timeout: 100000,
  headers: {
    Authorization: localStorage.getItem('jwt') ? `Bearer ${localStorage.getItem('jwt')}` : '',
    'Content-Type': 'application/json', "accept":"*/*"
  }
});

export const developmentAxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_DEVELOPMENT,
  timeout: 100000,
  headers: {
    Authorization: localStorage.getItem('jwt') ? `Bearer ${localStorage.getItem('jwt')}` : '',
    'Content-Type': 'application/json', "accept":"*/*"
  }
});